module.exports = __webpack_public_path__ + "img/three.8b4defa0.png";